import React from "react"
import styled from "styled-components"

const ListBadge = styled.div`
  margin: 0;
`
const ListBadgeItem = styled.div`
  display: flex;
  flex-wrap: wrap;
  margin: 0 -6px 20px -6px;
`
const Badge = styled.div`
  padding: 0 6px;
  position: relative;
  input[type="radio"] {
    width: 100%;
    height: 100%;
    opacity: 0;
    position: absolute;
    left: 0;
    cursor: pointer;
  }
  label {
    border: 1px solid #e2e2e2;
    background-color: #fff;
    font-size: 14px;
    line-height: 26px;
    font-weight: 500;
    padding: 6px 24px;
    color: #666;
    cursor: pointer;
    display: inline-block;
    margin: 6px;
    border-radius: 100px;
    transition: color 0.5s ease-in-out, background-color 0.5s ease-in-out,
      border-color 0.5s ease-in-out;
  }
  input[type="radio"]:checked {
    + label {
      background: #0b619b;
      color: #fff;
    }
  }
`

const LabelTitle = styled.div`
  font-weight: 700;
`

const ListNumbers = styled.div`
  margin: 0;
`
const ListNumberItem = styled.div`
  display: flex;
  flex-wrap: wrap;
  margin: 0 -3px 20px -3px;
`
const NumberBadge = styled.div`
  padding: 0 3px;
  position: relative;
  input[type="radio"] {
    width: 100%;
    height: 100%;
    opacity: 0;
    position: absolute;
    left: 0;
    cursor: pointer;
  }
  label {
    min-width: 50px;
    min-height: 38px;
    margin: 3px;
    background: #fff;
    border: 1px solid #d5d5d5;
    font-size: 14px;
    font-weight: 700;
    border-radius: 6px;
    text-align: center;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    transition: color 0.5s ease-in-out, background-color 0.5s ease-in-out,
      border-color 0.5s ease-in-out;
  }
  input[type="radio"]:checked {
    + label {
      background: #0b619b;
      color: #fff;
    }
  }
`

function BuildingRequirment () {
  return (
    <>
      <ListBadge>
        <LabelTitle>Choose Building Type</LabelTitle>
        <ListBadgeItem>
          <Badge>
            <input
              id="garages"
              name="buildingtype"
              type="radio"
              value="Garages"
              defaultChecked
            />
            <label htmlFor="garages">Garages</label>
          </Badge>
          <Badge>
            <input
              id="carports"
              name="buildingtype"
              type="radio"
              value="Carports"
            />
            <label htmlFor="carports">Carports</label>
          </Badge>
          <Badge>
            <input
              id="metal-buildings"
              name="buildingtype"
              type="radio"
              value="Metal Buildings"
            />
            <label htmlFor="metal-buildings">Metal Buildings</label>
          </Badge>
          <Badge>
            <input
              id="agriculture-buildings"
              name="buildingtype"
              type="radio"
              value="Agriculture Buildings"
            />
            <label htmlFor="agriculture-buildings">
              Agriculture Buildings
            </label>
          </Badge>
        </ListBadgeItem>
      </ListBadge>

      <ListNumbers>
        <LabelTitle>Width</LabelTitle>
        <ListNumberItem>
          <NumberBadge>
            <input id="width-12" name="width" type="radio" value="12" defaultChecked aria-label="width 12" />
            <label htmlFor="width-12">12</label>
          </NumberBadge>
          <NumberBadge>
            <input id="width-18" name="width" type="radio" value="18" aria-label="width 18" />
            <label htmlFor="width-18">18</label>
          </NumberBadge>
          <NumberBadge>
            <input id="width-20" name="width" type="radio" value="20" aria-label="width 20" />
            <label htmlFor="width-20">20</label>
          </NumberBadge>
          <NumberBadge>
            <input id="width-22" name="width" type="radio" value="22" aria-label="width 22" />
            <label htmlFor="width-22">22</label>
          </NumberBadge>
          <NumberBadge>
            <input id="width-24" name="width" type="radio" value="24" aria-label="width 24" />
            <label htmlFor="width-24">24</label>
          </NumberBadge>
          <NumberBadge>
            <input id="width-26" name="width" type="radio" value="26" aria-label="width 26" />
            <label htmlFor="width-26">26</label>
          </NumberBadge>
          <NumberBadge>
            <input id="width-28" name="width" type="radio" value="28" aria-label="width 28" />
            <label htmlFor="width-28">28</label>
          </NumberBadge>
          <NumberBadge>
            <input id="width-30" name="width" type="radio" value="30" aria-label="width 30" />
            <label htmlFor="width-30">30</label>
          </NumberBadge>
          <NumberBadge>
            <input id="width-32" name="width" type="radio" value="32" aria-label="width 32" />
            <label htmlFor="width-32">32</label>
          </NumberBadge>
          <NumberBadge>
            <input id="width-34" name="width" type="radio" value="34" aria-label="width 34" />
            <label htmlFor="width-34">34</label>
          </NumberBadge>
          <NumberBadge>
            <input id="width-36" name="width" type="radio" value="36" aria-label="width 36" />
            <label htmlFor="width-36">36</label>
          </NumberBadge>
          <NumberBadge>
            <input id="width-38" name="width" type="radio" value="38" aria-label="width 38" />
            <label htmlFor="width-38">38</label>
          </NumberBadge>
          <NumberBadge>
            <input id="width-40" name="width" type="radio" value="40" aria-label="width 40" />
            <label htmlFor="width-40">40</label>
          </NumberBadge>
          <NumberBadge>
            <input id="width-50" name="width" type="radio" value="50" aria-label="width 50" />
            <label htmlFor="width-50">50</label>
          </NumberBadge>
          <NumberBadge>
            <input id="width-60" name="width" type="radio" value="60" aria-label="width 60" />
            <label htmlFor="width-60">60</label>
          </NumberBadge>
        </ListNumberItem>
        <LabelTitle>Length</LabelTitle>
        <ListNumberItem>
          <NumberBadge>
            <input id="length-20" name="length" type="radio" value="20" defaultChecked aria-label="length 20" />
            <label htmlFor="length-20">20</label>
          </NumberBadge>
          <NumberBadge>
            <input id="length-25" name="length" type="radio" value="25" aria-label="length 25" />
            <label htmlFor="length-25">25</label>
          </NumberBadge>
          <NumberBadge>
            <input id="length-30" name="length" type="radio" value="30" aria-label="length 30" />
            <label htmlFor="length-30">30</label>
          </NumberBadge>
          <NumberBadge>
            <input id="length-35" name="length" type="radio" value="35" aria-label="length 35" />
            <label htmlFor="length-35">35</label>
          </NumberBadge>
          <NumberBadge>
            <input id="length-40" name="length" type="radio" value="40" aria-label="length 40" />
            <label htmlFor="length-40">40</label>
          </NumberBadge>
          <NumberBadge>
            <input id="length-45" name="length" type="radio" value="45" aria-label="length 45" />
            <label htmlFor="length-45">45</label>
          </NumberBadge>
          <NumberBadge>
            <input id="length-50" name="length" type="radio" value="50" aria-label="length 50" />
            <label htmlFor="length-50">50</label>
          </NumberBadge>
          <NumberBadge>
            <input id="length-55" name="length" type="radio" value="55" aria-label="length 55" />
            <label htmlFor="length-55">55</label>
          </NumberBadge>
          <NumberBadge>
            <input id="length-60" name="length" type="radio" value="60" aria-label="length 60" />
            <label htmlFor="length-60">60</label>
          </NumberBadge>
          <NumberBadge>
            <input id="length-65" name="length" type="radio" value="65" aria-label="length 65" />
            <label htmlFor="length-65">65</label>
          </NumberBadge>
          <NumberBadge>
            <input id="length-70" name="length" type="radio" value="70" aria-label="length 70" />
            <label htmlFor="length-70">70</label>
          </NumberBadge>
          <NumberBadge>
            <input id="length-75" name="length" type="radio" value="75" aria-label="length 75" />
            <label htmlFor="length-75">75</label>
          </NumberBadge>
          <NumberBadge>
            <input id="length-80" name="length" type="radio" value="80" aria-label="length 80" />
            <label htmlFor="length-80">80</label>
          </NumberBadge>
          <NumberBadge>
            <input id="length-85" name="length" type="radio" value="85" aria-label="length 85" />
            <label htmlFor="length-85">85</label>
          </NumberBadge>
          <NumberBadge>
            <input id="length-90" name="length" type="radio" value="90" aria-label="length 90" />
            <label htmlFor="length-90">90</label>
          </NumberBadge>
          <NumberBadge>
            <input id="length-95" name="length" type="radio" value="95" aria-label="length 95" />
            <label htmlFor="length-95">95</label>
          </NumberBadge>
          <NumberBadge>
            <input id="length-100" name="length" type="radio" value="100" aria-label="length 100" />
            <label htmlFor="length-100">100</label>
          </NumberBadge>
        </ListNumberItem>
        <LabelTitle>Height</LabelTitle>
        <ListNumberItem>
          <NumberBadge>
            <input id="height-6" name="height" type="radio" value="6" defaultChecked aria-label="height 6" />
            <label htmlFor="height-6">6</label>
          </NumberBadge>
          <NumberBadge>
            <input id="height-7" name="height" type="radio" value="7" aria-label="height 7" />
            <label htmlFor="height-7">7</label>
          </NumberBadge>
          <NumberBadge>
            <input id="height-8" name="height" type="radio" value="8" aria-label="height 8" />
            <label htmlFor="height-8">8</label>
          </NumberBadge>
          <NumberBadge>
            <input id="height-9" name="height" type="radio" value="9" aria-label="height 9" />
            <label htmlFor="height-9">9</label>
          </NumberBadge>
          <NumberBadge>
            <input id="height-10" name="height" type="radio" value="10" aria-label="height 10" />
            <label htmlFor="height-10">10</label>
          </NumberBadge>
          <NumberBadge>
            <input id="height-11" name="height" type="radio" value="11" aria-label="height 11" />
            <label htmlFor="height-11">11</label>
          </NumberBadge>
          <NumberBadge>
            <input id="height-12" name="height" type="radio" value="12" aria-label="height 12" />
            <label htmlFor="height-12">12</label>
          </NumberBadge>
          <NumberBadge>
            <input id="height-13" name="height" type="radio" value="13" aria-label="height 13" />
            <label htmlFor="height-13">13</label>
          </NumberBadge>
          <NumberBadge>
            <input id="height-14" name="height" type="radio" value="14" aria-label="height 14" />
            <label htmlFor="height-14">14</label>
          </NumberBadge>
          <NumberBadge>
            <input id="height-15" name="height" type="radio" value="15" aria-label="height 15" />
            <label htmlFor="height-5">15</label>
          </NumberBadge>
          <NumberBadge>
            <input id="height-16" name="height" type="radio" value="16" aria-label="height 16" />
            <label htmlFor="height-16">16</label>
          </NumberBadge>
          <NumberBadge>
            <input id="height-17" name="height" type="radio" value="17" aria-label="height 17" />
            <label htmlFor="height-17">17</label>
          </NumberBadge>
          <NumberBadge>
            <input id="height-18" name="height" type="radio" value="18" aria-label="height 18" />
            <label htmlFor="height-18">18</label>
          </NumberBadge>
          <NumberBadge>
            <input id="height-19" name="height" type="radio" value="19" aria-label="height 19" />
            <label htmlFor="height-19">19</label>
          </NumberBadge>
          <NumberBadge>
            <input id="height-20" name="height" type="radio" value="20" aria-label="height 20" />
            <label htmlFor="height-20">20</label>
          </NumberBadge>
        </ListNumberItem>
      </ListNumbers>
    </>
  )  
}
export default BuildingRequirment
